export default {
    client: 'Canceled by client',
    dealer: 'Canceled by dealer',
};
